import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FaqGetParams, FaqList } from './faq.model';

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  readonly #http = inject(HttpClient);
  readonly #faqUrl = `${environment.authHost}/api/faq/`;

  getFaq({ query, limit, offset }: FaqGetParams) {
    return this.#http.get<FaqList>(this.#faqUrl, {
      params: {
        ...(query ? { query } : {}),
        limit,
        offset
      }
    });
  }
}
